import React, { useEffect, useState } from "react";
import { View } from "react-native";
import commonStyles from "../../../styles/commonStyles";
import OverflowTooltipText from "../../../components/OverflowTooltipText";
import { Gender, mapDbGenderToEnum } from "../../../common/enums/Gender";
import { mapEmploymentStatus } from "../../../common/enums/EmploymentStatus";
import {
  AccreditedInvestor,
  HouseholdIncome,
  ImmigrationStatus,
  MaritalStatus} from "../../../mockData/personalDetailsMockData";
import { ScrollView } from "react-native-gesture-handler";
import { IUserTypes } from "../../../types/IUserTypes";
import AppText from "../../../components/AppText";
import PersonalDetailsStyle from "./PersonalDetailsStyle";

interface ProfileViewProps {
  userData: IUserTypes;
}
const PersonalDetailsView: React.FC<ProfileViewProps> = ({ userData }) => {
  useEffect(() => {
    // console.log("the dsata i s", userData);
  }, []);
  return (
    <ScrollView contentContainerStyle={PersonalDetailsStyle.viewContainer}>
      <View style={[commonStyles.subDetails]}>
        {/* <AppText style={commonStyles.subTitle}>First Name</AppText> */}
        <OverflowTooltipText
          text="First Name"
          style={commonStyles.subTitle}
          containerWidth="40%"
        />
        <OverflowTooltipText
          text={userData.firstName}
          style={commonStyles.subValue}
          containerWidth="58%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Middle Name</AppText> */}
        <OverflowTooltipText
          text="Middle Name"
          style={commonStyles.subTitle}
          containerWidth="47%"
        />
        <OverflowTooltipText
          text={userData.middleName}
          style={commonStyles.subValue}
          containerWidth="53%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Last Name</AppText> */}
        <OverflowTooltipText
          text="Last Name"
          style={commonStyles.subTitle}
          containerWidth="40%"
        />
        <OverflowTooltipText
          text={userData.lastName}
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Email</AppText>
        <OverflowTooltipText
          text={userData.email}
          style={commonStyles.subValue}
          containerWidth="70%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Gender</AppText>
        <OverflowTooltipText
          text={mapDbGenderToEnum(userData.gender)}
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Employment Status</AppText> */}
        <OverflowTooltipText
          text="Employment Status"
          style={commonStyles.subTitle}
          containerWidth="50%"
        />
        <OverflowTooltipText
          text={mapEmploymentStatus(userData.employmentStatus)}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Household Income</AppText> */}
        <OverflowTooltipText
          text="Household Income"
          style={commonStyles.subTitle}
          containerWidth="50%"
        />
        <OverflowTooltipText
          text={
            HouseholdIncome.find(
              (value) => value.value === userData.householdIncome
            )?.title || ""
          }
          style={commonStyles.subValue}
          containerWidth="50%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Marital Status</AppText>
        <OverflowTooltipText
          text={
            MaritalStatus.find(
              (value) => value.value === userData.maritalStatus
            )?.title || ""
          }
          style={commonStyles.subValue}
          containerWidth="50%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Phone Number</AppText> */}
        <OverflowTooltipText
          text="Phone Number"
          style={commonStyles.subTitle}
          containerWidth="50%"
        />
        <OverflowTooltipText
          text={userData.phoneNumber}
          style={commonStyles.subValue}
          containerWidth="50%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Accredited Investor</AppText> */}
        <OverflowTooltipText
          text="Accredited Investor"
          style={commonStyles.subTitle}
          containerWidth="60%"
        />
        <OverflowTooltipText
          text={
            AccreditedInvestor.find(
              (value) => value.value === userData.accreditedInvestor
            )?.title || ""
          }
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        {/* <AppText style={commonStyles.subTitle}>Immigration Status</AppText> */}
        <OverflowTooltipText
          text="Immigration Status"
          style={commonStyles.subTitle}
          containerWidth="60%"
        />
        <OverflowTooltipText
          text={
            ImmigrationStatus.find(
              (value) => value.value === userData.immigrationStatus
            )?.title || ""
          }
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
    </ScrollView>
  );
};

export default PersonalDetailsView;
